import React from "react";

import { colors } from "@zapalacorp/tokens";
import { Add } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../../../../../components/Form";
import { Color } from "../../../../../../../../../../components/Form/Button";
import { LoadingSpinner } from "../../../../../../../../../../components/LoadingModal/styles";
import { ButtonWrapper, CreateRulesComponentWrapper, SubTitle, Title } from "./styles";

interface ICreateRulesComponent {
  isLoadingJobTypes: boolean;
  handleCreateRule: () => void;
}

export const CreateRulesComponent = ({
  isLoadingJobTypes,
  handleCreateRule,
}: ICreateRulesComponent) => {
  const { t: translate } = useTranslation();

  if (isLoadingJobTypes) return <LoadingSpinner />;

  return (
    <CreateRulesComponentWrapper>
      <Title>{translate("itLooksLikeThereIsNoRulesAdded")}</Title>
      <SubTitle>{translate("youCanStartByAddingANewRuleByClickingTheButtonBellow")}</SubTitle>
      <ButtonWrapper>
        <Button
          customColor={Color.SECONDARY_DARK}
          startIcon={<Add size="20" color={colors.white} />}
          data-cy="button-create-role"
          onClick={handleCreateRule}
        >
          {translate("addARule")}
        </Button>
      </ButtonWrapper>
    </CreateRulesComponentWrapper>
  );
};
